import { render, staticRenderFns } from "./TabTitle.vue?vue&type=template&id=8416cd38&"
import script from "./TabTitle.vue?vue&type=script&lang=js&"
export * from "./TabTitle.vue?vue&type=script&lang=js&"
import style0 from "./TabTitle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports